/**
 * IncidentListWidget — compact list of active incidents.
 */

import { useEffect, useState } from "react";
import { apiFetch } from "../../../lib/config";

interface Incident {
  id: string;
  title: string;
  severity: string;
  status: string;
}

interface Props {
  config: Record<string, unknown>;
}

export function IncidentListWidget({ config }: Props) {
  const limit = (config.limit as number) ?? 5;
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiFetch(`/api/v1/incidents/?limit=${limit}&status=active`)
      .then((r) => r.json())
      .then((d) => setIncidents(Array.isArray(d) ? d : d.results ?? []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [limit]);

  if (loading) return <div className="aptean-widget-skeleton" style={{ height: 60 }} />;
  if (error) return <p style={{ color: "var(--aptean-error, #e74c3c)", margin: 0 }}>Error: {error}</p>;
  if (incidents.length === 0) return <p style={{ color: "var(--aptean-text-secondary)", margin: 0 }}>No active incidents.</p>;

  return (
    <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "grid", gap: 6 }}>
      {incidents.map((inc) => (
        <li
          key={inc.id}
          style={{
            padding: "6px 10px",
            borderRadius: 4,
            background: "var(--aptean-surface-2)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: "var(--aptean-text-primary)", fontSize: "0.85rem" }}>
            {inc.title}
          </span>
          <span
            style={{
              fontSize: "0.75rem",
              padding: "2px 6px",
              borderRadius: 10,
              background: "var(--aptean-error, #e74c3c)",
              color: "#fff",
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            {inc.severity}
          </span>
        </li>
      ))}
    </ul>
  );
}
